<template>
  <div class="joinus">
    <!-- banner -->
    <div style="width: 100%; position: relative">
      <img
        style="width: 100%; height: 100%"
        src="@/images/joinus/about.png"
        alt=""
      />
      <div
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        "
      >
        <span style="display: flex; align-items: center">
          <!-- <img
            style="
              font-size: 0;
              width: 0.36rem;
              height: 0.36rem;
              margin-right: 12px;
            "
            src="@/images/common/iconblue.png"
            alt=""
          /> -->
          <span class="txt">加入我们</span>
        </span>
      </div>
    </div>
    <!-- 招聘信息 -->
    <div style="width: 100%;overflow: hidden;">
      <div style="width: 12rem; margin: 0 auto 50px">
        <div
          class="box"
          v-for="item in list"
          :key="item.id"
          @click="tab(item.id)"
        >
          <div class="flex jsb pd" :class="item.active ? 'bg-blue' : 'bg-groy'">
            <div :class="item.active ? 'add_title' : 'null_title'">
              <span style="margin-right: 60px">{{ item.num }}</span
              ><span> {{ item.title }}</span>
            </div>
            <span
              :class="item.active ? ' el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div>
          <div v-if="item.active" class="border_top_null auto_pd text_p">
            <div v-html="item.text">{{ item.text }}</div>
            <div style="margin-top: 20px; display: flex; align-items: center">
              <img src="@/images/common/delivery.png" alt="" />
              <p class="test">
                如有意向，发送简历至邮箱：<span>hrbp@cargoee.com </span
                >，邮件主题：姓名+应聘职位。
              </p>
            </div>
            <div class="btn" @click="togo">了解凯通最新招聘信息</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      photolist: [
        {
          id: 1,
          url: "KJY_pic1.png",
        },
        {
          id: 2,
          url: "KJY_pic2.png",
        },
        {
          id: 3,
          url: "KJY_pic3.png",
        },
        {
          id: 4,
          url: "KJY_pic4.png",
        },
      ],
      list: [
        {
          id: 1,
          title: "货代操作（跨境电商）",
          num: "若干",
          active: true,
          text: " <p>岗位职责：</p><p>招聘人数：若干 任职资格：经公司专业培训后上岗</p><br /><p>1. 能独立从利润/满载/装箱合理性/直送还是拆箱柜等要求完成配箱流程；</p><p>2. 在规定时间完成正常报关流程，随时跟进装船进展；</p><p>3. 根据进仓数据收取海运费；</p><p>  4. 人品端正，具有敬业精神，具有团队合作精神，责任感及企业忠诚度强。</p><br /><p>任职资格：</p><p>1、大专以上学历，物流行业两年以上经验；</p><p>2、具有较强的理解能力，尤其是沟通协调能力，随机应变能力；</p><p>3、有跨境电商物流行业经验优先；</p><br /><p>【福利待遇】</p><p>1.带薪，不定期聚餐；</p><p>2.奖金：业务奖金；</p><p>3.保险：转正后为员工购买五险一金；</p><p>4.体检：每年都安排一次体检；</p><p>5.节日问候：各大节日发放节日礼金，礼品；</p><p>6.成长培训：公司包装个人品牌，提供内外系统培训学习，迅速成长；</p>",
        },
        {
          id: 2,
          title: "货代客服（国内/海外）",
          num: "2人",
          active: false,
          text: " <p>岗位职责：</p><p>招聘人数：2人 任职资格：经公司专业培训后上岗</p><br /><p>1. 协助业务员为客户提供货运相关的咨询工作，促进成单，妥善跟踪管理出运全流程；</p><p>2. 跟进销售工作，定期联系、了解客户需求，及时做好询报价工作，提高客情关系；</p><p>3. 根据客户委托，合理安排、协调操作做好订舱、商检、报关、拖车等货物出运事宜；</p><p>  4. 根据客户需求量身定制全套货运方案，确保客户满意度。</p><br /><p>任职资格：</p><p>1、大专以上学历，物流行业两年以上经验；</p><p>2、具有较强的理解能力，尤其是沟通协调能力，随机应变能力；</p><p>3、有跨境电商物流行业经验优先；</p><br /><p>【福利待遇】</p><p>1.带薪，不定期聚餐；</p><p>2.奖金：业务奖金；</p><p>3.保险：转正后为员工购买五险一金；</p><p>4.体检：每年都安排一次体检；</p><p>5.节日问候：各大节日发放节日礼金，礼品；</p><p>6.成长培训：公司包装个人品牌，提供内外系统培训学习，迅速成长；</p>",
        },
        {
          id: 3,
          title: "总助/CEO助理/董事长助理",
          num: "3人 ",
          active: false,
          text: " <p>岗位职责：</p><p>招聘人数：3人 任职资格：经公司专业培训后上岗</p><br /><p>1. 负责协助CEO跟踪公司各部门工作计划；</p><p>2. 协助CEO联络维护客户、供应商、投资人、政府等外部关系；</p><p>3. 整理CEO日常工作行程，及时提醒重要事项与关键节点，并进行相关准备；</p><p>  4. 根据CEO要求，收集整理相关信息，尤其是外文信息。</p><br /><p>任职资格：</p><p>1、本科以上学历（重点高校应届生也可），法律金融类专业或英语流利为佳；</p><p>2、文字功底强，善于独立思考；</p><p>3、具有亲和力，善于处理人际关系，逻辑强做事高效；</p><p>4、一定抗压能力，善于自己思考解决问题；</p><br /><p>【福利待遇】</p><p>1.带薪，不定期聚餐；</p><p>2.奖金：业务奖金；</p><p>3.保险：转正后为员工购买五险一金；</p><p>4.体检：每年都安排一次体检；</p><p>5.节日问候：各大节日发放节日礼金，礼品；</p><p>6.成长培训：公司包装个人品牌，提供内外系统培训学习，迅速成长；</p>",
        },
        {
          id: 4,
          title: "渠道BD专员",
          num: "5人",
          active: false,
          text: " <p>岗位职责：</p><p>招聘人数：5人 任职资格：经公司专业培训后上岗</p><br /><p>1. 负责新渠道（如：平台、商会、协会、跨境生态伙伴）渠道的开发和维护；</p><p>2. 根据不同渠道需求和属性，策划渠道活动和维护更新渠道活动；</p><p>3. 为渠道客户提供优质的咨询服务，包括业务介绍、公司活动、海运产品知识等相关信息；</p><p>  4. 对内跨部门，跨职能，协调执⾏落地，推进项⽬进度，负责产品内外流量获取及资源置换拓展⼯作，通过内外部资源权益拓展有效流量；</p><p>  5. 执行公司的市场策略及政策，达成业绩考核及个人成长的各项目标。</p><br /><p>任职资格：</p><p>1、大专及以上学历，一年以上跨境行业相关经历；</p><p>2、年龄22-35周岁，形象气质佳，有较强的商务拓展和合作洽谈经验，能深入挖掘潜在资源，进行深度合作；</p><p>3、条理清晰、逻辑性强，是敢于面对压力，具备良好的团队协调能力；</p><p>4、较强服务心态与意识，开放心态，主动思考如何优化公司产品和客户服务，对营销工作充满激情；</p><br /><p>【福利待遇】</p><p>【福利待遇】</p><p>1.带薪，不定期聚餐；</p><p>2.奖金：业务奖金；</p><p>3.保险：转正后为员工购买五险一金；</p><p>4.体检：每年都安排一次体检；</p><p>5.节日问候：各大节日发放节日礼金，礼品；</p><p>6.成长培训：公司包装个人品牌，提供内外系统培训学习，迅速成长；</p>",
        },
        {
          id: 5,
          title: "财务经理 ",
          num: "1人",
          active: false,
          text: " <p>岗位职责：</p><p>招聘人数：1人 任职资格：经公司专业培训后上岗</p><br /><p>1. 负责财务管理体系建设，包括财务核算、资金与预算管理、财务监督与分析、内部控制体系等，并对有效性进行监控；</p><p>2. 负责财务账目处理，外部财务报告及内部分析报告；公司总体纳税筹划的监督监控，降低税收成本，享受税收优惠政策；</p><p>3. 做好部门人员培训，定期检查各项财务规章制度执行；</p><p>  4. 熟悉财税相关法律法规，政策。</p><p>  5. 有跨境物流相关企业工作经验优先。</p><br /><p>【福利待遇】</p><p>1.带薪，不定期聚餐；</p><p>2.奖金：业务奖金；</p><p>3.保险：转正后为员工购买五险一金；</p><p>4.体检：每年都安排一次体检；</p><p>5.节日问候：各大节日发放节日礼金，礼品；</p><p>6.成长培训：公司包装个人品牌，提供内外系统培训学习，迅速成长；</p>",
        },
      ],
    };
  },
  components: {},
  methods: {
    tab(val) {
      this.list.forEach((item) => {
        item.id === val ? (item.active = true) : (item.active = false);
      });
    },
    togo() {
      window.open(
        "https://www.zhipin.com/gongsir/b56a148bc3f678500nBz3dq8Fw~~.html?ka=company-jobs"
      );
    },
  },
};
</script>
<style scoped>
.joinus {
  width: 100%;
  background: #f6f7f9;
}
.warper {
  width: 10rem;
  margin: 0 auto;
}
.txt {
  font-size: 40px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.title {
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: center;
  line-height: 50px;
}
.tigs {
  font-size: 24px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #727375;
  line-height: 33px;
  text-align: center;
}
.photobox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 50px 0;
}
.photobox img {
  width: 240px;
  height: 280px;
  font-size: 0;
  transform: scale(1.1);
}
/* 招聘信息 */
.box {
  margin-bottom: 10px;
}

.jsb {
  justify-content: space-between;
}
.pd {
  padding: 0 30px;
}
.bg-blue {
  background: #3b6aff;
  color: #fff;
}
.bg-groy {
  background: #ffff;
  color: #000;
}
.add_title {
  font-size: 18px;
  line-height: 48px;
  font-family: HiraginoSansGB;
  font-weight: normal;
  color: #ffffff;
}
.null_title {
  font-size: 18px;
  line-height: 48px;
  font-family: HiraginoSansGB;
  font-weight: normal;
  color: #000;
}
.el-icon-arrow-down,
.el-icon-arrow-up {
  font-size: 24px;
}
.el-icon-arrow-down {
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #3f4b50;
  background: #f7f7f7;
  border-radius: 1px;
}
.border_top_null {
  border-bottom: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
}
.auto_pd {
  padding: 50px 60px 31px 60px;
}
.border_top_null p {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000028;
  line-height: 32px;
}
img {
  width: 28px;
  height: 28px;
  margin-right: 16px;
}
.test {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #464646;
  line-height: 32px;
}
.test span {
  color: #3d8cff;
}
.btn {
  width: 184px;
  height: 40px;
  background: #3d8cff;
  border-radius: 1px;
  line-height: 40px;
  text-align: center;
  margin-top: 22px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.text_p p{
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #555;
  margin: 0px;
}
/* 招聘信息 end */
</style>



// WEBPACK FOOTER //
// src/components/joinus/index.vue